import React, { Fragment } from 'react';
import createSvgIcon from '../createSvgIcon';

const Download = () => {
  const Icon = createSvgIcon({
    title: 'Download',
    width: '32px',
    height: '32px',
    viewBox: '0 0 24 24',
    content: /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "a11"
    }, /*#__PURE__*/React.createElement("rect", {
      y: "19",
      width: "22",
      height: "3",
      fill: "none"
    })), /*#__PURE__*/React.createElement("clipPath", {
      id: "b22"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "-976",
      y: "-146",
      width: "1096",
      height: "942.55",
      fill: "none"
    })), /*#__PURE__*/React.createElement("clipPath", {
      id: "c33"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "9.63",
      width: "3",
      height: "15.58",
      fill: "none"
    })), /*#__PURE__*/React.createElement("clipPath", {
      id: "d44"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "-1065.6",
      y: "-132",
      width: "1195.64",
      height: "864",
      fill: "none"
    })), /*#__PURE__*/React.createElement("clipPath", {
      id: "e55"
    }, /*#__PURE__*/React.createElement("polygon", {
      points: "11 17.99 5.44 12.43 7.39 10.49 11 14.1 14.61 10.49 16.56 12.43 11 17.99",
      fill: "none",
      clipRule: "evenodd"
    })), /*#__PURE__*/React.createElement("clipPath", {
      id: "f66"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "-976",
      y: "-132",
      width: "1096",
      height: "864",
      fill: "none"
    })), /*#__PURE__*/React.createElement("clipPath", {
      id: "g77"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "-23",
      y: "30",
      width: "22",
      height: "3",
      fill: "none"
    })), /*#__PURE__*/React.createElement("clipPath", {
      id: "h99"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "-13.38",
      y: "11",
      width: "3",
      height: "15.58",
      fill: "none"
    }))), /*#__PURE__*/React.createElement("title", null, "downloadfile_icons"), /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#a11)"
    }, /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#b22)"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "-5",
      y: "13.55",
      width: "32",
      height: "13.91",
      fill: "#fff"
    }))), /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#c33)"
    }, /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#d44)"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "4.17",
      y: "-5",
      width: "13.91",
      height: "25.58",
      fill: "#fff"
    }))), /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#e55)"
    }, /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#f66)"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "0.44",
      y: "5.49",
      width: "21.11",
      height: "17.5",
      fill: "#fff"
    }))))
  });
  return /*#__PURE__*/React.createElement(Icon, null);
};

export default Download;